import React from 'react'
import './PoweredBar.css'

function PoweredBar() {
  return (
    <div className="ecd-powered-bar">
      <p className="powered-p-tag" style={{textAlign:"center", padding: 0, margin:0, alignItems:"center"}}><a href='https://easychatdesk.com' className='poweredBy' target='_blank' >Powered by EasyChatDesk</a></p></div>
  )
}

export default PoweredBar